import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=26e7e746&scoped=true&"
import script from "./TabItem.vue?vue&type=script&lang=js&"
export * from "./TabItem.vue?vue&type=script&lang=js&"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=26e7e746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7e746",
  null
  
)

export default component.exports